export const LOG_SERVICES = {
	PASARELA_GET_INFO_TYPE_PAYMENT: 'Pasarela -> GetInfoTypePayment'
};